import {linkPattern, linkTagWrapperPattern} from '../constants/patterns.const';

export function buildTagLink(message: string): string {
  return message.replace(linkPattern, linkTagWrapperPattern);
}
